import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Radio, { RadioGroup } from 'material-ui/Radio';
import { FormLabel, FormControl, FormControlLabel, /* FormHelperText */ } from 'material-ui/Form';
import SimpleCard from './SimpleCard';
import Typography from 'material-ui/Typography';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing.unit * 3,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
    textAlign: 'left',
  },
  option: {
    marginRight: 0,
    marginLeft: -30,
  },
});

const info = {
  'turn-1': {
    key: 'turn-1',
    headline: 'Turno 1: 18 - 19 de abril',
    content: <Typography component="p">Este turno se celebra el jueves 18 y el viernes 19 de abril, jueves y viernes santo.</Typography>
  },
  'turn-2': {
    key: 'turn-2',
    headline: 'Turno 2: 20 - 21 de abril',
    content: <Typography component="p">Este turno se celebra el sábado 20 y el domingo 21 de abril, terminando la Semana Santa.</Typography>
  },
  'default': {
    key: 'default',
    headline: 'Elige tu opción',
    content: <Typography component="p">¿En qué turno va a competir este equipo?. No dudes mucho que las plazas se agotan.</Typography>
  }
};

class RadioButtonsGroup extends React.Component {
  constructor(props){
    super(props);
    if (this.props.selectedOption) {
      this.state = {
        value: this.props.selectedOption.key
      };
    }else{
      this.state = {
        value: 'default'
      }
    }
  }

  handleChange = (event, value) => {
    this.setState({ value });
    this.props.choiceHandler( info[value] );
  };

  render() {
    const { classes } = this.props;

    return (
        <div>
      <div className={classes.root}>
        <FormControl component="fieldset" required className={classes.formControl}>
          <FormLabel component="legend">Opciones de inscripción</FormLabel>
          <RadioGroup
            aria-label="registryOptions"
            name="registryOptions1"
            className={classes.group}
            value={this.state.value}
            onChange={this.handleChange}
          >
            <FormControlLabel value="turn-1" control={<Radio />} label={info['turn-1'].headline} className={classes.option}/>
            <FormControlLabel value="turn-2" control={<Radio />} label={info['turn-2'].headline} className={classes.option}/>
            {/* <FormControlLabel value="disabled" disabled control={<Radio />} label="Disabled" /> */}
          </RadioGroup>
        </FormControl>
      </div>
        <SimpleCard title="Opciones de inscripción" headline={info[this.state.value || 'default'].headline} content={info[this.state.value || 'default'].content}/>
        </div>
    );
  }
}

RadioButtonsGroup.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RadioButtonsGroup);


// WEBPACK FOOTER //
// ./src/components/ChooseDates.jsx